import styled from "styled-components";
import { s } from "@shared/styles";

const MenuIconWrapper = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 6px;
  margin-left: -4px;
  color: ${s("textSecondary")};
  flex-shrink: 0;
`;

export default MenuIconWrapper;
